<template>
  <div :data-testid="`${type}-widget`" class="mb-4">
    <Title v-if="title.length" :title="title" />
    <Summary v-if="type === 'summary'" :data="data" />
    <TextContent v-if="type === 'text'" :data="data" />
    <Table v-if="type === 'table'" :data="data" />
    <EmptyState v-if="type === 'empty-state'" :data="data" />
    <InfoPanel v-if="type === 'info-panel'" :data="data" />
    <ActionList v-if="type === 'action-list'" :data="data" />
    <ChartWidget v-if="type === 'chart'" :data="data" />
    <IconsList v-if="type === 'icons-list'" :data="data" />
    <SummaryCard v-if="type === 'summary-card'" :data="data" />
    <ActionsButton v-if="type === 'action-button'" :data="data" />
    <GlobalMap v-if="type === 'map'" :data="data" />
    <UserList v-if="type === 'user-list'" :data="data" />
    <Spacer v-if="type === 'spacer'" />
    <ValidatedImpactsRepresentation
      v-if="type === 'explanation_graphic'"
      :data="data"
    />
  </div>
</template>

<script>
import Title from '@/containers/ReportsView/Widgets/Title.vue'
import Summary from '@/containers/ReportsView/Widgets/Summary.vue'
import TextContent from '@/containers/ReportsView/Widgets/TextContent.vue'
import Table from '@/containers/ReportsView/Widgets/Table.vue'
import EmptyState from '@/containers/ReportsView/Widgets/EmptyState.vue'
import InfoPanel from '@/containers/ReportsView/Widgets/InfoPanel.vue'
import ActionList from '@/containers/ReportsView/Widgets/ActionList.vue'
import ChartWidget from '@/containers/ReportsView/Widgets/ChartWidget.vue'
import IconsList from '@/containers/ReportsView/Widgets/IconsList.vue'
import SummaryCard from '@/containers/ReportsView/Widgets/SummaryCard.vue'
import ActionsButton from '@/containers/ReportsView/Widgets/ActionsButton.vue'
import GlobalMap from '@/containers/ReportsView/Widgets/GlobalMap.vue'
import UserList from '@/containers/ReportsView/Widgets/UserList.vue'
import Spacer from '@/containers/ReportsView/Widgets/Spacer.vue'
import ValidatedImpactsRepresentation from './ValidatedImpactsRepresentation.vue'

export default {
  name: 'WidgetsDispatcher',

  components: {
    Title,
    Summary,
    TextContent,
    Table,
    EmptyState,
    InfoPanel,
    ActionList,
    ChartWidget,
    IconsList,
    SummaryCard,
    ActionsButton,
    GlobalMap,
    UserList,
    Spacer,
    ValidatedImpactsRepresentation,
  },

  props: {
    widget: {
      type: Object,
      required: true,
    },
  },

  computed: {
    type() {
      return this.widget?.type ?? ''
    },
    title() {
      return this.widget?.title ?? ''
    },
    data() {
      return this.widget?.data ?? {}
    },
  },
}
</script>
